import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAbacavir} from "./TextDrugAbacavir"


export default function Abacavir() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      

  
    <ButtonsText onClick={handleOpen} name='Abacavir' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Abacavir - PGx Recommendation"
        content={ <TextDrugAbacavir />}

    />

</>
)}